// extracted by mini-css-extract-plugin
module.exports = {"tab":"mantine_tab__NSBrp","scrollbar":"mantine_scrollbar__JEp2K","thumb":"mantine_thumb__X6bfB","corner":"mantine_corner__BlJvf"};